export const SEO = {
  head: {
    title: 'Gousto Menus & Meal Planning | Get 50% Off Your First Box',
    meta: [
      {
        name: 'description',
        content:
          'Make your week easier with Gousto’s menus and meal planning. Explore the menu, what types of meals we have and how our menu works.',
      },
    ],
  },
}
